import Vue from 'vue'
import { mapState } from 'vuex'
import { CURRENCIES } from '@/constants/currency'
import PreferredCurrencies from '@/partials/PreferredCurrencies/PreferredCurrencies.vue'
import { formatDate, getDiff } from '@/utils/date'
import { formatUsd } from '@/utils/moneyFormat'

export default Vue.extend<any, any, any, any>({
  components: {
    PreferredCurrencies,
  },
  computed: {
    ...mapState({
      application: (state: any) => state.jobChat.application.value,
    }),
    job() {
      return this.application.job
    },
    hasDelivery() {
      return !!this.job.delivery_time_at
    },
    daysLeft() {
      const days = Math.max(getDiff(this.job.delivery_time_at, Date.now(), 'day'), 0)
      return days === 1 ? `${days} day` : `${days} days`
    },
    deliveryFormat() {
      return formatDate(this.job.delivery_time_at, 'MMM Do, YYYY')
    },
    budget() {
      return formatUsd(this.job.budget)
    },
    jobCurrencies() {
      return CURRENCIES
    },
  },
})
